import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import Parser from 'html-react-parser';
import runtimeConfig from '../config/runtimeConfig';

const Alert = ({
    id,
    content = '',
    loading = false,
    onCloseCallback = Function.prototype,
    appearance
}) => {
    const contentRef = useRef();

    const onClose = () => {
        onCloseCallback(id);
    };

    const getMainClass = () => {
        const extraClass = appearance !== 'default' ? `alert-${appearance}` : '';

        return classNames({
            'alert': true,
            [extraClass]: Boolean(extraClass)
        });
    };

    const setContent = () => {
        if (contentRef.current) {
            contentRef.current.innerHTML = content;
        }
    };

    useEffect(() => {
        setContent();
    }, [content]);

    return (
        <div className={getMainClass()}>
            <div className="alert__inner">
                <div className="alert__inner-social">
                    <a href={runtimeConfig.social && runtimeConfig.social.telegram} target="_blank">
                        <i className="fa fa-telegram" />
                    </a>
                </div>
                <div className="alert__inner-message" ref={contentRef} />
            </div>
            <button type="button" className="close" onClick={onClose} disabled={loading}>
                <span aria-hidden="true">×</span>
                <span className="sr-only">Close</span>
            </button>
        </div>
    );
};

export default Alert;
